import { createContext, useContext, useState, useEffect } from "react";
import translations from "./translations";

const I18nContext = createContext();

export const I18nProvider = ({ children }) => {
  const [locale, setLocale] = useState(() => localStorage.getItem("complianceos_lang") || "en");

  useEffect(() => {
    localStorage.setItem("complianceos_lang", locale);
  }, [locale]);

  const t = (key) => {
    return translations[locale]?.[key] || translations["en"]?.[key] || key;
  };

  return (
    <I18nContext.Provider value={{ locale, setLocale, t }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => {
  const context = useContext(I18nContext);
  if (!context) throw new Error("useI18n must be used within I18nProvider");
  return context;
};
